export const api = {
    auth    : process.env.VUE_APP_APIAUTH,
    public  : process.env.VUE_APP_APIPUBLIC,
    private : process.env.VUE_APP_APIPRIVATE,
    checkToken  : process.env.VUE_APP_API_CHECKTOKEN,
    wp : process.env.VUE_APP_APIWP
}

export const storage    = 'ps-app'
